export default __webpack_public_path__ + "static/media/english-to-norwegian-screenshot-06.2813a48f.png";